import { render, staticRenderFns } from "./DadosDaEmpresa.vue?vue&type=template&id=a8458a4e"
import script from "./DadosDaEmpresa.vue?vue&type=script&lang=js"
export * from "./DadosDaEmpresa.vue?vue&type=script&lang=js"
import style0 from "./DadosDaEmpresa.vue?vue&type=style&index=0&id=a8458a4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports